<template>
  <div class="timer-shaft-wrapper">
    <div v-if="isShowCalendar" class="calendar-wrapper">
      <el-date-picker
        v-model="showDate"
        :editable="false"
        :clearable="false"
        :readonly="!isCanOpenCalendar"
        :picker-options="pickerOptions"
        class="date-picker"
        @change="datePickerChange"
      />
    </div>
    <div v-if="isShowOperate" class="operate">
      <!-- <span
        :class="{ active: playOrder === PLAY_ORDER.BACKWARDS }"
        class="prev icon"
        title="倒序播放"
        @click="changePlayOrder(PLAY_ORDER.BACKWARDS)"
      >
      </span>
      <span
        :class="{ active: playOrder === PLAY_ORDER.FORWARD }"
        class="next icon"
        title="顺序播放"
        @click="changePlayOrder(PLAY_ORDER.FORWARD)"
      >
      </span> -->
      <span
        :class="{
          play: playStatus === PLAY_STATUS.PAUSE,
          pause: playStatus === PLAY_STATUS.PLAYING
        }"
        :title="playStatus === PLAY_STATUS.PAUSE ? '播放' : '暂停'"
        class="play-status icon"
        @click="changePlayStatus()"
      >
      </span>
    </div>
    <div
      ref="processWrapper"
      class="process-wrapper"
      @click.stop="changeProcess"
      @mousemove.stop="processMouseenter"
      @mouseleave.stop="processMouseleave"
    >
      <div :style="{ left: percentWidth + '%' }" class="process-tips">
        <div></div>
        <span>{{ $moment(processTime).format('HH:[00]') }}</span>
      </div>
      <div
        v-show="isShowProcessHover"
        :style="{ left: processTipsHoverLeft + '%' }"
        class="process-hover-tips"
      >
        <div></div>
        <span>{{ $moment(processHoverTime).format('HH:[00]') }}</span>
      </div>
      <div class="process-line">
        <!--进度条-->
        <div
          :style="{ width: percentWidth + '%' }"
          :class="{ complete: percentWidth === 100 }"
          class="process"
        ></div>
        <!--当前时间的进度条位置-->
        <div
          :style="{
            marginLeft: -(cellPercentWidth / 2) + '%',
            width: cellPercentWidth + '%',
            left: percentWidth + '%'
          }"
          class="current-process"
        ></div>
        <ul
          v-for="(item, index) in dateList"
          :key="index"
          :style="{ width: (item.hasHours / cellLength) * 100 + '%' }"
        >
          <li
            v-for="(scale, scaleIndex) in item.scaleList"
            :key="scaleIndex"
            :style="{
              width: index === 0 && scaleIndex === 0 ? '0px' : '1px',
              left: (scale.prevCellHours / cellLength) * 100 + '%'
            }"
          ></li>
        </ul>
      </div>
      <!--进度条的刻度号码-->
      <div ref="scaleWrapper" class="scale-wrapper">
        <div
          v-for="(item, index) in dateList"
          :key="index"
          :style="{ width: (item.hasHours / cellLength) * 100 + '%' }"
          class="scale-container"
        >
          <ol class="scale">
            <li
              v-for="(scale, scaleIndex) in item.scaleList"
              :key="scaleIndex"
              :style="{ width: (scale.interval / item.hasHours) * 100 + '%' }"
            >
              <span
                v-if="scaleIndex !== 0"
                :style="{
                  width: SCALE_CELL_WIDTH + 'px',
                  marginLeft: -SCALE_CELL_WIDTH / 2 + 'px'
                }"
                >{{ scale.scaleNum }}</span
              >
            </li>
          </ol>
          <div class="week">
            <template v-if="item.isShow">{{
              $moment(item.day).format('YYYY/MM/DD')
            }}</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FORMAT_TIMER_SHAFT,
  FORMAT_TIMER_SHAFT_ZERO,
  FORMAT_DATE,
  FORMAT_TIMESTAMP,
  PLAY_ORDER,
  PLAY_STATUS
} from '@/utils/constants';
/**
 * 地图-时间轴
 */
export default {
  props: {
    /**
     * 是否显示日历
     */
    isShowCalendar: {
      type: Boolean,
      default: true
    },
    /**
     * 是否可以打开日历
     */
    isCanOpenCalendar: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示操作按钮
     */
    isShowOperate: {
      type: Boolean,
      default: true
    },
    /**
     * 初始结束时间
     */
    initEndTime: {
      type: [String, Number],
      required: true
    },
    /**
     * 初始开始时间
     */
    initStartTime: {
      type: [String, Number],
      required: true
    },
    /**
     * 时间轴播放速度（单位：秒）
     */
    intervalSecond: {
      type: Number,
      default: 2
    },
    defaultPlayStatus: {
      type: Number,
      default: () => PLAY_STATUS.PAUSE
    },
    processChangeCallback: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      INTERVAL: 0, // 刻度间隔
      SCALE_NUMBER: [],
      SCALE_CELL_WIDTH: 12, // 每个刻度的宽度
      pickerOptions: {
        disabledDate: time => {
          const current = this.$moment(time);
          return !current.isBetween(
            this.$moment().add(-1, 'year'),
            this.$moment()
          );
        }
      },
      processTime: this.$moment(this.initStartTime, FORMAT_TIMER_SHAFT), // 进度条时间
      startTime: this.$moment(this.initStartTime, FORMAT_TIMER_SHAFT),
      endTime: this.$moment(this.initEndTime, FORMAT_TIMER_SHAFT),

      scaleList: [],
      showDate: this.initStartTime,
      PLAY_ORDER,
      PLAY_STATUS,
      playOrder: PLAY_ORDER.FORWARD,
      playStatus: PLAY_STATUS.PAUSE,
      percentWidth: 0,
      cellLength: 0, // 总刻度
      dateList: [], // 日期列表
      currentTimer: null,
      processHoverTime: new Date(),
      processTipsHoverLeft: 0,
      isShowProcessHover: false,
      cellPercentWidth: 0
    };
  },

  watch: {},

  destroyed() {
    this.playStatus = PLAY_STATUS.PAUSE;
  },

  mounted() {
    this.init();
    if (
      this.$moment().isSame(this.startTime, 'minutes') ||
      this.$moment().isSame(this.endTime, 'minutes') ||
      this.$moment().isBetween(this.startTime, this.endTime, 'minutes')
    ) {
      this.processTime = this.$moment();
      const startTime = this.$moment(this.startTime);
      const percent = this.processTime.diff(startTime, 'h');
      this.percentWidth =
        (percent / this.cellLength) * 100 + this.cellPercentWidth / 2;
      this.$emit('processChange', {
        processTime: this.processTime.format(FORMAT_TIMER_SHAFT)
      });
    }
    if (this.defaultPlayStatus === PLAY_STATUS.PLAYING) {
      this.changePlayStatus();
    }
    this.calPercent();
  },

  methods: {
    async processChange(momentTime) {
      const processTime = momentTime.format(FORMAT_TIMER_SHAFT);
      this.processTime = this.$moment(momentTime);
      const timestamp = momentTime.format(FORMAT_TIMESTAMP);
      const preview = [];
      if (this.playOrder === PLAY_ORDER.FORWARD) {
        preview.push(momentTime.add(1, 'h').format(FORMAT_TIMESTAMP));
        preview.push(momentTime.add(1, 'h').format(FORMAT_TIMESTAMP));
      } else {
        preview.push(momentTime.subtract(1, 'h').format(FORMAT_TIMESTAMP));
        preview.push(momentTime.subtract(1, 'h').format(FORMAT_TIMESTAMP));
      }
      if (this.processChangeCallback) {
        await this.processChangeCallback({
          processTime,
          timestamp,
          preview
        });
      } else {
        this.$emit('processChange', {
          processTime,
          timestamp,
          preview
        });
      }
    },

    /**
     * 鼠标离开进度条区域
     */
    processMouseleave() {
      this.isShowProcessHover = false;
    },
    processMouseenter(e) {
      const offsetX =
        e.clientX - this.$refs.scaleWrapper.getBoundingClientRect().x;
      if (offsetX >= 0 && offsetX <= this.$refs.scaleWrapper.clientWidth) {
        const diffHours = Math.floor(
          (this.cellLength * offsetX) / this.$refs.scaleWrapper.clientWidth
        );
        this.processTipsHoverLeft =
          (offsetX / this.$refs.scaleWrapper.clientWidth) * 100;
        this.processHoverTime = this.$moment(this.startTime)
          .add(diffHours, 'h')
          .format(FORMAT_TIMER_SHAFT);
        this.isShowProcessHover = true;
      } else {
        this.isShowProcessHover = false;
      }
    },
    /**
     * 点击进度条
     */
    changeProcess(e) {
      const offsetX =
        e.clientX - this.$refs.scaleWrapper.getBoundingClientRect().x;
      const diffHours = Math.floor(
        (this.cellLength * offsetX) / this.$refs.scaleWrapper.clientWidth
      );
      this.percentWidth = (offsetX / this.$refs.scaleWrapper.clientWidth) * 100;
      const processTime = this.$moment(this.startTime).add(diffHours, 'h');
      this.processChange(processTime);
      // 如果正在播放就暂停
      if (this.playStatus === PLAY_STATUS.PLAYING) {
        this.changePlayStatus();
      }
    },
    /**
     * 改变播放顺序
     */
    changePlayOrder(order) {
      if (this.playOrder === order) {
        return;
      }
      if (this.playOrder === PLAY_ORDER.FORWARD) {
        this.playOrder = PLAY_ORDER.BACKWARDS;
      } else if (this.playOrder === PLAY_ORDER.BACKWARDS) {
        this.playOrder = PLAY_ORDER.FORWARD;
      }
      // 如果正在播放就暂停
      if (this.playStatus === PLAY_STATUS.PLAYING) {
        this.changePlayStatus();
      }
      // 如果是变为向后播放，则进度条从最右边开始
      this.$emit('changePlayOrder', this.playOrder);
    },
    /**
     * 日历时间修改
     */
    datePickerChange(val) {
      const processTime = `${this.$moment(val).format(
        FORMAT_DATE
      )} ${this.$moment().format('HH:00:00')}`;
      this.startTime = this.$moment(val);
      this.endTime = this.$moment(val).add(this.diffHours, 'h');
      this.$emit('dateRangeChange', {
        start: this.startTime.format(FORMAT_TIMER_SHAFT),
        end: this.endTime.format(FORMAT_TIMER_SHAFT)
      });
      this.processChange(this.$moment(processTime, FORMAT_TIMER_SHAFT));
      this.initDateList();
      if (this.playStatus === PLAY_STATUS.PLAYING) {
        this.changePlayStatus();
      }
    },
    /**
     * 改变播放状态
     */
    changePlayStatus() {
      if (this.t) {
        clearTimeout(this.t);
      }
      if (this.playStatus === PLAY_STATUS.PLAYING) {
        this.playStatus = PLAY_STATUS.PAUSE;
      } else if (this.playStatus === PLAY_STATUS.PAUSE) {
        this.playStatus = PLAY_STATUS.PLAYING;
        const nextTick = () => {
          this.t = setTimeout(async () => {
            let processTime;
            if (this.playOrder === PLAY_ORDER.FORWARD) {
              processTime = this.$moment(this.processTime).add(3, 'h');
            } else if (this.playOrder === PLAY_ORDER.BACKWARDS) {
              processTime = this.$moment(this.processTime).subtract(3, 'h');
            }
            await this.processChange(processTime);
            this.calPercent();
            if (this.playStatus === PLAY_STATUS.PLAYING) {
              nextTick();
            }
          }, 1000 * this.intervalSecond);
        };
        nextTick();
      }
      this.$emit('changePlayStatus', this.playStatus);
    },
    /**
     * 计算进度条的宽度
     */
    calPercent() {
      const startTime = this.$moment(this.startTime);
      let processTime = this.$moment(this.processTime);
      const percent = processTime.diff(startTime, 'h');
      if (this.playOrder === PLAY_ORDER.FORWARD) {
        if (percent > this.cellLength - 1) {
          this.percentWidth = 0;
          processTime = this.$moment(this.startTime);
          this.processChange(processTime);
        } else {
          this.percentWidth = (percent / this.cellLength) * 100;
        }
      } else if (this.playOrder === PLAY_ORDER.BACKWARDS) {
        if (percent < 0) {
          this.percentWidth = (this.cellLength - 1) * this.cellPercentWidth;
          processTime = this.$moment(this.endTime);
          this.processChange(processTime);
        } else {
          this.percentWidth = (percent / this.cellLength) * 100;
        }
      }
    },
    initDateList() {
      const dateList = [];
      const diffHours = this.diffHours;
      const startTime = this.$moment(this.startTime);
      const endTime = this.$moment(this.endTime);
      let diffDays = 0;
      let day = this.$moment(startTime.format(FORMAT_TIMER_SHAFT_ZERO));
      while (!endTime.isSame(day, 'day')) {
        diffDays++;
        day.add(1, 'd');
      }
      diffDays++;
      // 当时长<=24小时，刻度显示间隔1小时，[01,02,03,...22,23]
      // 当时长<=4天，刻度显示间隔3小时，[03,06,09...21]
      // 当时长<=8天，刻度显示间隔6小时，[06,12,18]
      // 当时长<=16天，刻度显示间隔12小时，[12]
      // 当时长>16天，不显示刻度
      if (diffHours <= 24) {
        this.INTERVAL = 1;
        this.SCALE_NUMBER = [
          '00',
          '01',
          '02',
          '03',
          '04',
          '05',
          '06',
          '07',
          '08',
          '09',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
          '22',
          '23'
        ];
      } else if (diffDays <= 4) {
        this.INTERVAL = 3;
        this.SCALE_NUMBER = ['00', '03', '06', '09', '12', '15', '18', '21'];
      } else if (diffDays <= 8) {
        this.INTERVAL = 6;
        this.SCALE_NUMBER = ['00', '06', '12', '18'];
      } else if (diffDays <= 16) {
        this.INTERVAL = 12;
        this.SCALE_NUMBER = ['00', '12'];
      } else {
        this.INTERVAL = 24;
        this.SCALE_NUMBER = ['00'];
      }
      let prevCellHours = 0;
      for (let i = 0; i < diffDays; i++) {
        let hasHours = 24;
        let day = this.$moment(startTime).add(i, 'days');
        let isShow = true;
        let scaleList = [];
        if (i === 0) {
          hasHours = diffDays === 1 ? diffHours + 1 : 24 - startTime.hours();
          isShow = diffDays === 1 || hasHours >= 12;
          let firstScale = hasHours % this.INTERVAL;
          let currentTimeScaleLen = Math.floor(hasHours / this.INTERVAL);
          // interval当前刻度到下一个刻度的间距
          // scaleNum 当前的刻度号码
          // prevCellHour 前面一个刻度所对应的小时数
          if (firstScale !== 0) {
            scaleList.push({
              interval: firstScale,
              scaleNum: startTime.format('HH'),
              prevCellHours: 0
            });
          }
          if (currentTimeScaleLen !== 0) {
            let scaleNumList =
              diffDays === 1
                ? [...this.SCALE_NUMBER.slice(0, currentTimeScaleLen)]
                : [...this.SCALE_NUMBER.slice(-currentTimeScaleLen)];
            scaleNumList.forEach((item, index) => {
              scaleList.push({
                interval: this.INTERVAL,
                scaleNum: item,
                prevCellHours: index * this.INTERVAL + firstScale
              });
            });
          }
          prevCellHours = hasHours;
        } else if (i === diffDays - 1) {
          hasHours = endTime.hours() + 2;
          isShow = hasHours >= 12;
          let currentTimeScaleLen = Math.floor(hasHours / this.INTERVAL);
          let scaleNumList = [
            ...this.SCALE_NUMBER.slice(0, currentTimeScaleLen)
          ];
          let lastScale = hasHours % this.INTERVAL;

          if (currentTimeScaleLen !== 0) {
            scaleNumList.forEach((item, index) => {
              scaleList.push({
                interval: this.INTERVAL,
                scaleNum: item,
                prevCellHours: index * this.INTERVAL + prevCellHours
              });
            });
          }
          if (lastScale !== 0) {
            if (scaleList.length > 0) {
              scaleList.push({
                interval: lastScale,
                scaleNum: this.SCALE_NUMBER.slice(
                  currentTimeScaleLen,
                  currentTimeScaleLen + 1
                ).join(''),
                prevCellHours:
                  scaleList[scaleList.length - 1].prevCellHours + this.INTERVAL
              });
            } else {
              scaleList.push({
                interval: lastScale,
                scaleNum: this.SCALE_NUMBER.slice(
                  currentTimeScaleLen,
                  currentTimeScaleLen + 1
                ).join(''),
                prevCellHours: diffHours - endTime.hours() - 1
              });
            }
          }
        } else {
          let hasHours = 24;
          let scaleNumList = [...this.SCALE_NUMBER];
          scaleNumList.forEach((item, index) => {
            scaleList.push({
              interval: this.INTERVAL,
              scaleNum: item,
              prevCellHours: index * this.INTERVAL + prevCellHours
            });
          });
          prevCellHours += hasHours;
        }

        dateList.push({
          day: day,
          isShow: isShow,
          scaleList: scaleList,
          hasHours: hasHours
        });
      }
      this.dateList = dateList;
      //console.log('datelist', this.dateList);
    },
    init() {
      const endTime = this.$moment(this.endTime).subtract(1, 'seconds');
      const startTime = this.$moment(this.startTime);
      const diffHours = endTime.diff(startTime, 'h') + 1;
      this.diffHours = diffHours;
      this.initDateList();
      this.cellLength = diffHours + 1;
      this.cellPercentWidth = (1 / this.cellLength) * 100;
      // this.currentTimer = setInterval(() => {
      //   this.processTime = this.$moment();
      //   this.isShowCurrentProcess = this.processTime.isBetween(
      //     this.startTime,
      //     this.endTime,
      //     'minutes'
      //   );
      // }, 1000 * 60);
    }
  }
};
</script>

<style lang="less" scoped>
ul {
  margin: 0;
  padding: 0;
}

li {
  list-style-type: none;
}

.timer-shaft-wrapper {
  position: relative;
  border-radius: 4px;
  z-index: 2000;
  height: 42px;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;

  .calendar-wrapper {
    display: flex;
    width: 44px;
    justify-content: center;
    position: relative;
    height: 34px;
    border-right: 1px solid #cacaca;

    /deep/ .date-picker {
      display: flex;
      align-items: center;

      .el-input__inner {
        cursor: pointer;
        width: 124px;
        background: none !important;
        border: none;
        font-size: 16px;
        font-family: PingFangSC-Regular, serif;
        font-weight: 400;
        color: #0075b0;
        padding: 0 0 0 28px;
        display: none;
      }

      .el-input__prefix {
        color: #0075b0;
        display: flex;
        align-items: center;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }

      .el-icon-date {
        cursor: pointer;
        width: 15px;
        height: 16px;
        margin: 0 auto;
        background: url('../asset/timerShaft/calendar.png') 100% 100% no-repeat;

        &:before {
          content: none;
        }
      }
    }
  }

  .operate {
    display: flex;
    // flex: 0 0 90px;
    border-right: 1px solid #cacaca;
    height: 42px;
    align-items: center;

    .icon {
      display: inline-block;
      margin: 0 6px;
      width: 22px;
      height: 22px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;

      &:first-child {
        margin-left: 7px;
      }

      &:last-child {
        margin-right: 7px;
      }
    }

    .prev {
      background-image: url('../asset/timerShaft/previous.png');

      &.active {
        background-image: url('../asset/timerShaft/previous-active.png');
      }
    }

    .next {
      background-image: url('../asset/timerShaft/next.png');

      &.active {
        background-image: url('../asset/timerShaft/next-active.png');
      }
    }

    .play-status {
      &.play {
        background-image: url('../asset/timerShaft/play.png');
      }

      &.pause {
        background-image: url('../asset/timerShaft/pause.png');
      }
    }
  }

  .process-wrapper {
    position: relative;
    width: 100%;
    height: 42px;
    display: flex;
    text-align: center;
    align-items: center;
    cursor: pointer;

    .process-tips,
    .process-hover-tips {
      pointer-events: none;
      position: absolute;
      padding: 4px 8px;
      height: 26px;
      left: 0;
      bottom: 54px;
      color: #fff;
      font-size: 12px;
      z-index: 1002;
      border-radius: 4px;
      margin-left: -23.25px;

      div {
        width: 0;
        height: 0;
        border: 10px solid transparent;
        position: absolute;
        margin-left: -10px;
        left: 50%;
        top: 26px;
      }
    }

    .process-tips {
      background: #009845;

      div {
        border-top-color: #009845;
      }
    }

    .process-hover-tips {
      background: rgba(0, 0, 0, 0.3);

      div {
        border-top-color: rgba(0, 0, 0, 0.3);
      }
    }

    //当前日期进度
    .current-process {
      position: absolute;
      height: 9px;
      top: 0;
      background: #a8cb09;
    }

    .process {
      position: absolute;
      height: 9px;
      top: 0;
      background: #009845;

      &.complete {
        border-top-right-radius: 4px;
      }
    }

    //刻度线
    .process-line {
      width: 100%;
      display: flex;
      margin: 0;
      position: absolute;
      height: 9px;
      top: 0;
      left: 0;
      right: 0;
      background: #cacaca;
      border-top-right-radius: 4px;
      overflow: hidden;

      li {
        display: block;
        height: 9px;
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        background: hsla(0, 0%, 100%, 0.38);
      }
    }

    //刻度
    .scale-wrapper {
      font-size: 12px;
      color: #047ca6;
      height: 33px;
      width: 100%;
      display: flex;
      margin-top: 9px;

      .scale-container {
        padding: 0;
        margin: 0;
        border-right: 1px solid #cacaca;

        &:last-child {
          border: none;
        }

        .week {
          margin: 0;
          padding: 0;
          height: 20px;
          line-height: 20px;
        }

        .line {
          height: 7px;
          margin: 0 auto;
          width: 1px;
          background: #fff;
        }

        .scale {
          display: flex;
          margin: 0;
          width: 100%;
          padding: 0;
          border-bottom: 1px solid #cacaca;

          li {
            display: flex;
            align-items: center;
            height: 12px;

            span {
              text-align: center;
              display: block;
              font-size: 12px;
              color: #037ba5;
              font-family: Adobe Heiti Std R, serif;
              font-weight: normal;
            }
          }
        }
      }
    }
  }
}
</style>
